/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { OAuthClientUIConfiguration } from './OAuthClientUIConfiguration';
import {
    OAuthClientUIConfigurationFromJSON,
    OAuthClientUIConfigurationFromJSONTyped,
    OAuthClientUIConfigurationToJSON,
    OAuthClientUIConfigurationToJSONTyped,
} from './OAuthClientUIConfiguration';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetOauth2UiConfiguration200Response
 */
export interface GetOauth2UiConfiguration200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetOauth2UiConfiguration200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetOauth2UiConfiguration200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {OAuthClientUIConfiguration}
     * @memberof GetOauth2UiConfiguration200Response
     */
    result: OAuthClientUIConfiguration;
}

/**
 * Check if a given object implements the GetOauth2UiConfiguration200Response interface.
 */
export function instanceOfGetOauth2UiConfiguration200Response(value: object): value is GetOauth2UiConfiguration200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetOauth2UiConfiguration200ResponseFromJSON(json: any): GetOauth2UiConfiguration200Response {
    return GetOauth2UiConfiguration200ResponseFromJSONTyped(json, false);
}

export function GetOauth2UiConfiguration200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOauth2UiConfiguration200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': OAuthClientUIConfigurationFromJSON(json['result']),
    };
}

export function GetOauth2UiConfiguration200ResponseToJSON(json: any): GetOauth2UiConfiguration200Response {
    return GetOauth2UiConfiguration200ResponseToJSONTyped(json, false);
}

export function GetOauth2UiConfiguration200ResponseToJSONTyped(value?: GetOauth2UiConfiguration200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': OAuthClientUIConfigurationToJSON(value['result']),
    };
}

